import { render, staticRenderFns } from "./itemCollectionLog.vue?vue&type=template&id=5c5a7416&scoped=true&"
import script from "./itemCollectionLog.vue?vue&type=script&lang=js&"
export * from "./itemCollectionLog.vue?vue&type=script&lang=js&"
import style0 from "./itemCollectionLog.vue?vue&type=style&index=0&id=5c5a7416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a7416",
  null
  
)

export default component.exports